/**
 * Created by DSadler on 28/04/2017.
 */
import React, {Component} from 'react';
import {Divider, Drawer, List, ListItem} from "material-ui";
import {NavLink} from "react-router-dom";
import {ActionHome, ImageEdit} from "material-ui/svg-icons/index";
import './LeftNav.css'

class LeftNav extends Component {
  
  render() {
    return (
      <Drawer
        className="left-nav"
        docked={this.props.pinned}
        open={this.props.open}
        onRequestChange={this.props.handleChange}
        containerStyle={!this.props.pinned ? null : {top: "64px"}}
      >
      <List>
        <ListItem
          disabled
          style={{
            textAlign: "center",
            fontWeight: "bold"
          }}
        >
          HTML Email Designer
        </ListItem>
        <Divider/>
        <NavLink to="/" exact={true}>
          <ListItem
            onTouchTap={() => !this.props.pinned && this.props.handleChange(false)}
            leftIcon={<ActionHome/>}
          >
            Homepage
          </ListItem>
        </NavLink>
        <NavLink to="/editor">
          <ListItem
            onTouchTap={() => !this.props.pinned && this.props.handleChange(false)}
            leftIcon={<ImageEdit/>}
          >
            Editor
          </ListItem>
        </NavLink>
      </List>
      </Drawer>
    );
  }
}

export default LeftNav;


// WEBPACK FOOTER //
// ./src/App/components/LeftNav.js